import React from 'react';
import RawGenericDatePicker from '../generic-date-picker/RawGenericDatePicker';

function RawWeekpicker({disabled, startDate, label, endDate, ...props}) {
    return (
        <div>
            <RawGenericDatePicker
                disabled={disabled}
                selectsRange={true}
                weekPicker
                dateFormat={'dd MMM yyyy'}
                {...props}
                startDate={startDate}
                endDate={endDate}
                label={label}
            />
        </div>
    );
}

export {RawWeekpicker};
